import { withSvgIcon } from './withSvgIcon';

export const FilterAlt = withSvgIcon(
  <path
    d="M3 6H21M11 18H13M7 12H17"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
